import { Trans } from '@lingui/macro'
import styled from 'styled-components/macro'
import { ExternalLink, ThemedText } from 'theme'

const StyledLink = styled(ExternalLink)`
  font-weight: 600;
  color: ${({ theme }) => theme.textSecondary};
`

const LastUpdatedText = styled.span`
  color: ${({ theme }) => theme.textTertiary};
`

const TermPolicyTextWrapper = styled.span`
  line-height: 24px;
  color: ${({ theme }) => theme.purple};
`

export default function PrivacyPolicyNotice() {
  return (
    <ThemedText.Caption color="textSecondary">
      <Trans>By connecting a wallet, you agree to XSwap Labs&apos;</Trans>{' '}
      <StyledLink href="https://docs.xspswap.finance/xswap-protocol/general-terms-and-conditions">
        <Trans>
          <TermPolicyTextWrapper>Terms of Service</TermPolicyTextWrapper>
        </Trans>{' '}
      </StyledLink>
      <Trans>and consent to its</Trans>{' '}
      <StyledLink href="https://docs.xspswap.finance/xswap-protocol/responsible-risk-disclosure-policy">
        <Trans>
          <TermPolicyTextWrapper>Privacy Policy.</TermPolicyTextWrapper>
        </Trans>
      </StyledLink>
    </ThemedText.Caption>
  )
}
